import { WidgetSelectDropdown } from '../../rapid-ui'

export const fontOptions = [
	{ id: 'Crimson Pro Variable', label: <div style={{ fontFamily: 'Crimson Pro Variable' }}>Crimson Pro</div> },
	{ id: 'DM Sans Variable', label: <div style={{ fontFamily: 'DM Sans Variable' }}>DM Sans</div> },
	{
		id: 'Jetbrains Mono Variable',
		label: <div style={{ fontFamily: 'Jetbrains Mono Variable' }}>Jetbrains Mono</div>,
	},
	{ id: 'Lora Variable', label: <div style={{ fontFamily: 'Lora Variable' }}>Lora</div> },
	{ id: 'Merriweather Variable', label: <div style={{ fontFamily: 'Merriweather Variable' }}>Merriweather</div> },
	{ id: 'Noto Sans Variable', label: <div style={{ fontFamily: 'Noto Sans Variable' }}>Noto Sans</div> },
	{ id: 'Onest', label: <div>Onest</div> },
	{ id: 'Open Sans Variable ', label: <div style={{ fontFamily: 'Open Sans Variable' }}>Open Sans</div> },
	{
		id: 'Playfair Display Variable',
		label: <div style={{ fontFamily: 'Playfair Display Variable' }}>Playfair Display</div>,
	},
	{ id: 'Raleway Variable', label: <div style={{ fontFamily: 'Raleway Variable' }}>Raleway</div> },
	{ id: 'Rubik Variable', label: <div style={{ fontFamily: 'Rubik Variable' }}>Rubik</div> },
]

export type WidgetFontSelectDropdownProps = {
	value: string
	onChange: (value: string) => void
	allowDefault?: boolean
}

export function WidgetFontSelectDropdown({ value, onChange, allowDefault = false }: WidgetFontSelectDropdownProps) {
	return (
		<>
			<WidgetSelectDropdown
				options={fontOptions}
				value={value}
				onChange={onChange}
				label="Font"
				allowDefault={allowDefault}
			/>
		</>
	)
}
